module.exports = __webpack_public_path__ + "static/innumeracy-3c92d4537626ec30300d366f696f8f75.jpg";